<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uZlWaR/tc-custom/9781250124333.jpg?1738254612479" alt="This image is the cover for the book Legends of the Lost Causes"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Legends of the Lost Causes
      </h1>
      <p class="bookDescription body article font2">
        <p>A band of orphan avengers. A cursed stone. A horde of zombie outlaws.<br/><br/>This is Keech Blackwood’s new life after Bad Whiskey Nelson descends upon the Home for Lost Causes and burns it to the ground.<br/><br/>With his home destroyed and his family lost, Keech will have to use the lessons he learned from Pa Abner to hunt down the powerful Char Stone. Luckily, he has the help of a ragtag team of orphans. Together, they’ll travel through treacherous forests, fight off the risen dead, and discover that they share mysterious bonds as they search for the legendary stone. Now it’s a race against the clock, because if Bad Whiskey finds the stone first…all is lost.<br/><br/>But Keech and the other orphans won’t hesitate. Because they’re more than just heroes.<br/>They’re Lost Causes.<br/><br/><b>Praise for <i>Legends of the Lost Causes<br/></i></b><br/>A Junior Library Guild selection<br/><br/>"This is a fun and exciting story, written with the utmost respect for the Osage culture." —Wah-Zha-Zhi Cultural Center</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brad McLelland, Louis Sylvester
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b3b34e1a